# Resolve Conflicts

When uploading files you may encounter a conflict. This is when a file with the same name already exists in the system.

You can resolve this conflict by renaming the uploaded file or replacing the existing file by clicking the appropriate buttons provided in the modal.

You may resolve each file conflict one by one by using the buttons next to the text. If you wish to resolve them all at once, you can use the buttons at the bottom of the modal.

export function KeepBothBtn() {
  return (
    <v-btn
      color="primary"
      variant="flat">
      <v-icon>mdi-content-duplicate</v-icon>
    </v-btn>
  );
}

### Keep Both (rename):

This button adds a number to the end of the file name. For example, if the file name is image.jpg and you click this button, the file name will be changed to image (1)

<KeepBothBtn />

### Replace (upgrade):

This button replaces the existing file with the new one.

export function ReplaceButton() {
  return (
    <v-btn
      color="primary"
      variant="flat">
      <v-icon>mdi-file-arrow-up-down</v-icon>
    </v-btn>
  );
}

<ReplaceButton />
